import apiClient from "api/api-client";
import { downloadBlobResponse } from "utils/download-blob";

export const useDownloadFile = () => {
  const downloadFile = async (id: number | string, fileName: string, publicId?: string) => {
    if (id === "") return;
    const response = await apiClient.get(`/files/${id}`, {
      ...(publicId ? { params: { publicId } } : {}),
      responseType: "blob",
    });
    downloadBlobResponse(response, fileName);
  };

  return { downloadFile };
};
